<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close"
                  @click="$emit('close')"
                  aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Reenviar pix e boleto
          </h4>
        </div>

        <div class="modal-body">
          <p v-if="student">
            Será enviado um novo pix e boleto para o seguinte e-mail: <strong>{{ student.email }}</strong>
          </p>
          <div v-if="inputError" class="alert alert-danger">
            {{ inputError }}
          </div>
          <p>Enviar também para outro e-mail?</p>
          <input ref="extraRecipient" class="form-input" type="email">
          <div class="checkbox-wrapper">
            <input type="checkbox" id="checkbox" v-model="includeSpecialDiscounts">
            <label for="checkbox">Incluir desconto de pontualidade no valor final</label>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-primary" @click="resendBill">
            Reenviar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BoletoAndPixResendService from 'services/BoletoAndPixResendService';

export default {
  data() {
    return {
      inputError: null,
      includeSpecialDiscounts: false,
    };
  },
  computed: {
    ...mapState([
      'student',
      'selectedBill',
    ]),
  },
  methods: {
    resendBill() {
      this.$loader.show();

      BoletoAndPixResendService
        .resend(
          this.selectedBill.id,
          this.$refs.extraRecipient.value,
          this.includeSpecialDiscounts,
        )
        .then(() => {
          this.$alert.notifySuccess('Boleto e Pix enviados com sucesso!');
          this.$emit('close');
        })
        .catch(({ response }) => {
          this.inputError = `Erro ao reenviar: ${response.data.message}`;
        })
        .finally(() => {
          this.$loader.hide();
        });
    },
  },
};
</script>

<style lang="scss">
.checkbox-wrapper {
  margin-top: 10px;
}
input#checkbox {
  margin-right: 5px;
}
</style>
